import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Batteria56V1500CicliOm({ idVariant = '', className }: Props) {
  return (
    <IconBase name="batteria56-v1500-cicli-om" w={80.363} h={105.005} className={className}>
      <g transform="translate(-27.566 -11.629)">
        <g>
          <defs>
            <rect
              id={`batteria56v1500cicliom_${idVariant}_SVGID_1_`}
              x="34.938"
              y="11.629"
              width="65.617"
              height="65.619"
            />
          </defs>
          <clipPath id={`batteria56v1500cicliom_${idVariant}_SVGID_2_`}>
            <use xlinkHref={`#batteria56v1500cicliom_${idVariant}_SVGID_1_`} overflow="visible" />
          </clipPath>
          <path
            clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_2_)`}
            fill="#9D9D9C"
            d="M68.526,77.248c17.69,0,32.03-14.34,32.03-32.032
      		c0-17.689-14.34-32.03-32.03-32.03s-32.03,14.341-32.03,32.03C36.496,62.908,50.836,77.248,68.526,77.248"
          />
          <path
            clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_2_)`}
            fill="#E3E5E8"
            d="M66.968,75.691c17.691,0,32.031-14.342,32.031-32.031
      		c0-17.69-14.34-32.031-32.031-32.031c-17.69,0-32.03,14.341-32.03,32.031C34.938,61.349,49.278,75.691,66.968,75.691"
          />
          <path
            clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_2_)`}
            fill="#FFFFFF"
            d="M77.712,65.675v-6.518c0-1.121-0.912-2.031-2.032-2.031H55.743
      		c-1.12,0-2.033,0.91-2.033,2.031v6.518c0,1.121,0.913,2.033,2.033,2.033H75.68C76.8,67.708,77.712,66.796,77.712,65.675"
          />
          <path
            clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M55.743,67.707c-1.12,0-2.033-0.91-2.033-2.031v-6.518
      		c0-1.121,0.913-2.031,2.033-2.031H75.68c1.12,0,2.032,0.91,2.032,2.031v6.518c0,1.121-0.912,2.031-2.032,2.031H55.743z
      		 M78.331,65.675v-0.307c0.039,0.012,0.078,0.023,0.121,0.023h1.357c0.236,0,0.43-0.193,0.43-0.43v-5.092
      		c0-0.236-0.193-0.43-0.43-0.43h-1.357c-0.043,0-0.082,0.014-0.121,0.023v-0.307c0-1.461-1.19-2.652-2.651-2.652H55.743
      		c-1.463,0-2.652,1.191-2.652,2.652v6.518c0,1.461,1.189,2.652,2.652,2.652H75.68C77.141,68.328,78.331,67.136,78.331,65.675"
          />
          <path
            clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_2_)`}
            fill="#EE7203"
            d="M58.572,58.443H56.33c-0.616,0-1.12,0.504-1.12,1.119v5.709
      		c0,0.615,0.504,1.119,1.12,1.119h2.242c0.615,0,1.119-0.504,1.119-1.119v-5.709C59.691,58.947,59.188,58.443,58.572,58.443"
          />
          <path
            clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_2_)`}
            fill="#EE7203"
            d="M64,58.443h-2.242c-0.616,0-1.12,0.504-1.12,1.119v5.709
      		c0,0.615,0.504,1.119,1.12,1.119H64c0.615,0,1.119-0.504,1.119-1.119v-5.709C65.119,58.947,64.615,58.443,64,58.443"
          />
          <path
            clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_2_)`}
            fill="#EE7203"
            d="M69.6,58.443h-2.242c-0.616,0-1.12,0.504-1.12,1.119v5.709
      		c0,0.615,0.504,1.119,1.12,1.119H69.6c0.615,0,1.119-0.504,1.119-1.119v-5.709C70.719,58.947,70.215,58.443,69.6,58.443"
          />
          <path
            clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_2_)`}
            fill="#EE7203"
            d="M75.093,58.443h-2.242c-0.617,0-1.121,0.504-1.121,1.119v5.709
      		c0,0.615,0.504,1.119,1.121,1.119h2.242c0.614,0,1.118-0.504,1.118-1.119v-5.709C76.211,58.947,75.707,58.443,75.093,58.443"
          />
          <path
            clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_2_)`}
            fill="#EE7203"
            d="M53.145,49.406V32.828h-3.138c-0.562,1.967-1.685,2.575-4.355,2.575v2.717
      		h3.138v11.286H53.145z"
          />
          <path
            clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_2_)`}
            fill="#EE7203"
            d="M53.502,42.357h3.934c0-1.007,0.468-1.404,1.194-1.404
      		c0.819,0,1.241,0.632,1.241,2.506c0,3.183-0.398,3.558-1.241,3.558c-0.749,0-1.194-0.443-1.194-2.014v-0.562h-4.074v0.539
      		c0,2.998,1.592,4.754,5.432,4.754c4.121,0,5.432-2.131,5.432-6.463c0-3.559-1.452-5.268-4.144-5.268
      		c-1.241,0-2.248,0.468-3.068,1.217l0.188-2.786H63.5v-3.277h-9.623L53.502,42.357z"
          />
          <path
            clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_2_)`}
            fill="#EE7203"
            d="M71.374,44.021c0,2.342-0.375,2.997-1.289,2.997
      		c-0.912,0-1.287-0.654-1.287-2.997v-5.479c0-2.341,0.375-2.997,1.287-2.997c0.914,0,1.289,0.656,1.289,2.997V44.021z
      		 M75.729,41.281c0-6.697-1.78-8.453-5.644-8.453c-3.862,0-5.642,1.756-5.642,8.453c0,6.697,1.78,8.453,5.642,8.453
      		C73.948,49.734,75.729,47.978,75.729,41.281"
          />
          <path
            clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_2_)`}
            fill="#EE7203"
            d="M82.876,44.021c0,2.342-0.375,2.997-1.287,2.997
      		c-0.914,0-1.289-0.654-1.289-2.997v-5.479c0-2.341,0.375-2.997,1.289-2.997c0.912,0,1.287,0.656,1.287,2.997V44.021z
      		 M87.231,41.281c0-6.697-1.78-8.453-5.643-8.453c-3.863,0-5.644,1.756-5.644,8.453c0,6.697,1.78,8.453,5.644,8.453
      		C85.451,49.734,87.231,47.978,87.231,41.281"
          />
          <path
            clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_2_)`}
            fill="#9D9D9C"
            d="M76.509,53.794c-0.02,1.188,0.984,1.715,2.052,1.715
      		c1.315,0,2.004-0.662,2.004-1.547c0-1.086-1.071-1.322-1.43-1.402c-1.209-0.305-1.438-0.359-1.438-0.73
      		c0-0.404,0.391-0.547,0.729-0.547c0.513,0,0.918,0.156,0.952,0.73h1.024c0-1.115-0.924-1.553-1.93-1.553
      		c-0.871,0-1.802,0.465-1.802,1.457c0,0.893,0.722,1.195,1.437,1.371c0.703,0.195,1.433,0.27,1.433,0.797
      		c0,0.492-0.567,0.602-0.939,0.602c-0.566,0-1.066-0.25-1.066-0.893H76.509z M72.438,55.394h3.658v-0.891h-2.6v-1.182h2.336V52.5
      		h-2.336v-1.033h2.545v-0.891h-3.604V55.394z M68.437,55.394h3.407v-0.891h-2.349v-3.928h-1.059V55.394z M67.672,52.195
      		c-0.128-1.113-1.026-1.734-2.079-1.734c-1.485,0-2.368,1.113-2.368,2.545c0,1.391,0.883,2.504,2.368,2.504
      		c1.188,0,2.011-0.764,2.119-1.971h-1.026c-0.081,0.641-0.445,1.08-1.093,1.08c-0.952,0-1.31-0.811-1.31-1.613
      		c0-0.846,0.358-1.654,1.31-1.654c0.52,0,0.979,0.365,1.053,0.844H67.672z M60.181,55.394h1.059v-1.85l1.789-2.969h-1.181
      		l-1.12,1.902l-1.127-1.902h-1.195l1.775,2.941V55.394z M58.168,52.195c-0.128-1.113-1.026-1.734-2.079-1.734
      		c-1.485,0-2.368,1.113-2.368,2.545c0,1.391,0.883,2.504,2.368,2.504c1.188,0,2.011-0.764,2.119-1.971h-1.026
      		c-0.08,0.641-0.445,1.08-1.093,1.08c-0.952,0-1.31-0.811-1.31-1.613c0-0.846,0.358-1.654,1.31-1.654
      		c0.52,0,0.979,0.365,1.053,0.844H58.168z"
          />
          <path
            clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M90.87,55.261l-0.354-0.248c2.924-5.699,3.694-11.802,2.236-18.301
      		c-0.992-4.422-3.05-8.322-6.059-11.717c-0.092-0.103-0.153-0.229-0.229-0.345c-0.807-0.778-1.614-1.559-2.421-2.338
      		c-0.803-0.585-1.592-1.191-2.41-1.753c-8.662-5.932-20.29-6.195-29.186-0.624c-1.314,0.823-2.504,1.844-3.752,2.771
      		c-0.111,0.082-0.23,0.153-0.346,0.229c-0.779,0.808-1.559,1.614-2.338,2.421c-0.597,0.818-1.239,1.607-1.784,2.458
      		c-5.235,8.171-6.042,16.761-2.361,25.746c1.096,2.68,2.676,5.068,4.607,7.223c0.091,0.102,0.158,0.227,0.237,0.342
      		c0.706,0.682,1.412,1.363,2.118,2.045c0.229,0.152,0.459,0.303,0.697,0.461c1.026-1.062,2.05-2.123,3.077-3.186
      		c-10.302-8.355-11.094-22.839-3.136-32.135c8.134-9.5,22.012-10.48,31.342-2.792c4.793,3.95,7.549,9.086,8.076,15.28
      		c0.363,4.278-0.349,8.147-2.027,11.631l-0.789-0.559l-2.436-1.705c-0.261-0.184-0.582-0.156-0.807,0.006
      		c-0.153,0.111-0.262,0.285-0.28,0.5l-1.026,11.807c-0.064,0.746,0.705,1.285,1.385,0.967l10.736-5.014
      		c0.043-0.02,0.082-0.043,0.117-0.068c0.371-0.271,0.385-0.848-0.014-1.127L90.87,55.261z"
          />
        </g>
        <g>
          <defs>
            <rect
              id={`batteria56v1500cicliom_${idVariant}_SVGID_3_`}
              x="36.566"
              y="79.216"
              width="62.363"
              height="37.418"
            />
          </defs>
          <clipPath id={`batteria56v1500cicliom_${idVariant}_SVGID_4_`}>
            <use xlinkHref={`#batteria56v1500cicliom_${idVariant}_SVGID_3_`} overflow="visible" />
          </clipPath>
          <g clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_4_)`}>
            <defs>
              <rect
                id={`batteria56v1500cicliom_${idVariant}_SVGID_5_`}
                x="36.566"
                y="79.216"
                width="62.361"
                height="37.418"
              />
            </defs>
            <clipPath id={`batteria56v1500cicliom_${idVariant}_SVGID_6_`}>
              <use xlinkHref={`#batteria56v1500cicliom_${idVariant}_SVGID_5_`} overflow="visible" />
            </clipPath>
            <g clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_6_)`}>
              <g>
                <defs>
                  <rect
                    id={`batteria56v1500cicliom_${idVariant}_SVGID_7_`}
                    x="27.566"
                    y="72.216"
                    width="80.363"
                    height="45.418"
                  />
                </defs>
                <clipPath id={`batteria56v1500cicliom_${idVariant}_SVGID_8_`}>
                  <use
                    xlinkHref={`#batteria56v1500cicliom_${idVariant}_SVGID_7_`}
                    overflow="visible"
                  />
                </clipPath>
                <rect
                  x="36.566"
                  y="79.216"
                  clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_8_)`}
                  fill="#FFFFFF"
                  width="62.361"
                  height="37.418"
                />
                <g clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_8_)`}>
                  <defs>
                    <rect
                      id={`batteria56v1500cicliom_${idVariant}_SVGID_9_`}
                      x="36.566"
                      y="79.216"
                      width="62.361"
                      height="37.418"
                    />
                  </defs>
                  <clipPath id={`batteria56v1500cicliom_${idVariant}_SVGID_10_`}>
                    <use
                      xlinkHref={`#batteria56v1500cicliom_${idVariant}_SVGID_9_`}
                      overflow="visible"
                    />
                  </clipPath>
                  <g
                    clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_10_)`}
                    enableBackground="new    "
                  >
                    <g>
                      <defs>
                        <rect
                          id={`batteria56v1500cicliom_${idVariant}_SVGID_11_`}
                          x="36.456"
                          y="79.106"
                          width="62.582"
                          height="37.637"
                        />
                      </defs>
                      <clipPath id={`batteria56v1500cicliom_${idVariant}_SVGID_12_`}>
                        <use
                          xlinkHref={`#batteria56v1500cicliom_${idVariant}_SVGID_11_`}
                          overflow="visible"
                        />
                      </clipPath>
                      <polygon
                        clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_12_)`}
                        fill="#F2C359"
                        points="67.974,87.827 81.681,87.377 79.462,89.022 65.659,91.837 
      															"
                      />
                      <polygon
                        clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_12_)`}
                        fill="#F2C359"
                        points="66.054,94.247 79.761,93.796 77.542,95.442 63.74,98.257 
      															"
                      />
                      <g clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_12_)`}>
                        <defs>
                          <rect
                            id={`batteria56v1500cicliom_${idVariant}_SVGID_13_`}
                            x="36.566"
                            y="79.216"
                            width="62.361"
                            height="37.418"
                          />
                        </defs>
                        <clipPath id={`batteria56v1500cicliom_${idVariant}_SVGID_14_`}>
                          <use
                            xlinkHref={`#batteria56v1500cicliom_${idVariant}_SVGID_13_`}
                            overflow="visible"
                          />
                        </clipPath>
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#F2C359"
                          d="M72.714,104.132c0,0,2.664-0.584,5.189-3.184
      									c2.523-2.602,2.188-5.158,2.479-4.752c0.293,0.406,0.857,3.052-0.855,5.348S74.769,104.411,72.714,104.132"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#F2C359"
                          d="M70.694,82.655c0,0-9.578-5.117-14.943,1.531
      									c-5.366,6.648-1.05,12.655,0.699,14.93c1.75,2.273,5.594,4.195,5.594,4.195s1.315,0.557,1.521,0.61
      									c0.206,0.055,0.425,0.124,0.425,0.124l-0.639-0.723c0,0-6.482-6.898-7.1-12.465C55.95,82.286,67.418,82.118,70.694,82.655"
                        />
                        <g
                          opacity="0.7933"
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          enableBackground="new    "
                        >
                          <g>
                            <defs>
                              <rect
                                id={`batteria56v1500cicliom_${idVariant}_SVGID_15_`}
                                x="49.039"
                                y="92.378"
                                width="6.61"
                                height="7.834"
                              />
                            </defs>
                            <clipPath id={`batteria56v1500cicliom_${idVariant}_SVGID_16_`}>
                              <use
                                xlinkHref={`#batteria56v1500cicliom_${idVariant}_SVGID_15_`}
                                overflow="visible"
                              />
                            </clipPath>
                            <g clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_16_)`}>
                              <defs>
                                <polygon
                                  id={`batteria56v1500cicliom_${idVariant}_SVGID_17_`}
                                  points="53.43,92.382 49.038,100.193 51.155,100.212 55.649,92.378 55.627,92.378 												
      													"
                                />
                              </defs>
                              <clipPath id={`batteria56v1500cicliom_${idVariant}_SVGID_18_`}>
                                <use
                                  xlinkHref={`#batteria56v1500cicliom_${idVariant}_SVGID_17_`}
                                  overflow="visible"
                                />
                              </clipPath>

                              <linearGradient
                                id={`batteria56v1500cicliom_${idVariant}_SVGID_19_`}
                                gradientUnits="userSpaceOnUse"
                                x1="14.8311"
                                y1="-2.9932"
                                x2="15.8311"
                                y2="-2.9932"
                                gradientTransform="matrix(-0.1869 7.8225 -13.1378 -0.1113 15.8984 -24.0039)"
                              >
                                <stop offset="0" stopColor="#356CB3" />
                                <stop offset="1" stopColor="#60C6F2" />
                              </linearGradient>
                              <polygon
                                clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_18_)`}
                                fill={`url(#batteria56v1500cicliom_${idVariant}_SVGID_19_)`}
                                points="49.039,92.322 48.851,100.211 55.647,100.269 
      												55.836,92.38 											"
                              />
                            </g>
                          </g>
                        </g>
                        <g
                          opacity="0.7933"
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          enableBackground="new    "
                        >
                          <g>
                            <defs>
                              <rect
                                id={`batteria56v1500cicliom_${idVariant}_SVGID_20_`}
                                x="56.866"
                                y="92.429"
                                width="9.814"
                                height="7.818"
                              />
                            </defs>
                            <clipPath id={`batteria56v1500cicliom_${idVariant}_SVGID_21_`}>
                              <use
                                xlinkHref={`#batteria56v1500cicliom_${idVariant}_SVGID_20_`}
                                overflow="visible"
                              />
                            </clipPath>
                            <g clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_21_)`}>
                              <defs>
                                <polygon
                                  id={`batteria56v1500cicliom_${idVariant}_SVGID_22_`}
                                  points="58.058,92.429 57.055,94.312 60.269,94.382 56.866,100.175 59.079,100.247 
      													62.32,94.382 65.677,94.329 66.681,92.431 66.657,92.429 												"
                                />
                              </defs>
                              <clipPath id={`batteria56v1500cicliom_${idVariant}_SVGID_23_`}>
                                <use
                                  xlinkHref={`#batteria56v1500cicliom_${idVariant}_SVGID_22_`}
                                  overflow="visible"
                                />
                              </clipPath>

                              <linearGradient
                                id={`batteria56v1500cicliom_${idVariant}_SVGID_24_`}
                                gradientUnits="userSpaceOnUse"
                                x1="14.8203"
                                y1="-2.9707"
                                x2="15.8203"
                                y2="-2.9707"
                                gradientTransform="matrix(-0.1869 7.8223 -13.1374 -0.1113 25.6016 -23.832)"
                              >
                                <stop offset="0" stopColor="#356CB3" />
                                <stop offset="1" stopColor="#60C6F2" />
                              </linearGradient>
                              <polygon
                                clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_23_)`}
                                fill={`url(#batteria56v1500cicliom_${idVariant}_SVGID_24_)`}
                                points="56.868,92.347 56.679,100.245 66.679,100.331 
      												66.868,92.431 											"
                              />
                            </g>
                          </g>
                        </g>
                        <g
                          opacity="0.7933"
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          enableBackground="new    "
                        >
                          <g>
                            <defs>
                              <rect
                                id={`batteria56v1500cicliom_${idVariant}_SVGID_25_`}
                                x="64.657"
                                y="92.401"
                                width="11.032"
                                height="7.92"
                              />
                            </defs>
                            <clipPath id={`batteria56v1500cicliom_${idVariant}_SVGID_26_`}>
                              <use
                                xlinkHref={`#batteria56v1500cicliom_${idVariant}_SVGID_25_`}
                                overflow="visible"
                              />
                            </clipPath>
                            <g clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_26_)`}>
                              <defs>
                                <polygon
                                  id={`batteria56v1500cicliom_${idVariant}_SVGID_27_`}
                                  points="69.126,92.408 64.657,100.321 64.662,100.321 66.859,100.257 70.155,94.292 
      													73.493,100.208 75.688,100.177 71.358,92.401 												"
                                />
                              </defs>
                              <clipPath id={`batteria56v1500cicliom_${idVariant}_SVGID_28_`}>
                                <use
                                  xlinkHref={`#batteria56v1500cicliom_${idVariant}_SVGID_27_`}
                                  overflow="visible"
                                />
                              </clipPath>

                              <linearGradient
                                id={`batteria56v1500cicliom_${idVariant}_SVGID_29_`}
                                gradientUnits="userSpaceOnUse"
                                x1="14.8271"
                                y1="-2.9902"
                                x2="15.8271"
                                y2="-2.9902"
                                gradientTransform="matrix(-0.1869 7.8225 -13.1378 -0.1113 33.7656 -23.8242)"
                              >
                                <stop offset="0" stopColor="#356CB3" />
                                <stop offset="1" stopColor="#60C6F2" />
                              </linearGradient>
                              <polygon
                                clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_28_)`}
                                fill={`url(#batteria56v1500cicliom_${idVariant}_SVGID_29_)`}
                                points="64.659,92.308 64.468,100.319 75.685,100.415 
      												75.876,92.403 											"
                              />
                            </g>
                          </g>
                        </g>
                        <g
                          opacity="0.7933"
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          enableBackground="new    "
                        >
                          <g>
                            <defs>
                              <rect
                                id={`batteria56v1500cicliom_${idVariant}_SVGID_30_`}
                                x="78.069"
                                y="92.437"
                                width="8.387"
                                height="7.744"
                              />
                            </defs>
                            <clipPath id={`batteria56v1500cicliom_${idVariant}_SVGID_31_`}>
                              <use
                                xlinkHref={`#batteria56v1500cicliom_${idVariant}_SVGID_30_`}
                                overflow="visible"
                              />
                            </clipPath>
                            <g clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_31_)`}>
                              <defs>
                                <path
                                  id={`batteria56v1500cicliom_${idVariant}_SVGID_32_`}
                                  d="M78.069,100.181h0.027h8.342l-0.014-1.873l-8.342-0.012L78.069,100.181z M78.089,95.347v1.969
      													l8.367,0.038l-0.025-2.031L78.089,95.347z M78.11,92.45l0.029,1.912l8.26-0.036v-1.89L78.11,92.45z"
                                />
                              </defs>
                              <clipPath id={`batteria56v1500cicliom_${idVariant}_SVGID_33_`}>
                                <use
                                  xlinkHref={`#batteria56v1500cicliom_${idVariant}_SVGID_32_`}
                                  overflow="visible"
                                />
                              </clipPath>

                              <linearGradient
                                id={`batteria56v1500cicliom_${idVariant}_SVGID_34_`}
                                gradientUnits="userSpaceOnUse"
                                x1="14.8203"
                                y1="-2.9697"
                                x2="15.8193"
                                y2="-2.9697"
                                gradientTransform="matrix(-0.1869 7.8223 -13.1374 -0.1113 46.1016 -23.6602)"
                              >
                                <stop offset="0" stopColor="#356CB3" />
                                <stop offset="1" stopColor="#60C6F2" />
                              </linearGradient>
                              <polygon
                                clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_33_)`}
                                fill={`url(#batteria56v1500cicliom_${idVariant}_SVGID_34_)`}
                                points="78.071,92.365 77.884,100.179 86.454,100.251 
      												86.642,92.438 											"
                              />
                            </g>
                          </g>
                        </g>
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M55.296,109.336c-0.268,0-0.514-0.062-0.739-0.187
      									c-0.225-0.123-0.405-0.307-0.541-0.549c-0.135-0.244-0.203-0.543-0.203-0.898c0-0.354,0.07-0.654,0.208-0.902
      									c0.139-0.25,0.323-0.441,0.553-0.574c0.23-0.131,0.479-0.197,0.747-0.197c0.205,0,0.389,0.042,0.552,0.125
      									c0.164,0.083,0.299,0.18,0.407,0.291l-0.382,0.46c-0.082-0.075-0.167-0.136-0.257-0.185c-0.09-0.047-0.192-0.07-0.306-0.07
      									c-0.143,0-0.275,0.041-0.394,0.123c-0.119,0.08-0.213,0.199-0.284,0.352c-0.07,0.153-0.105,0.338-0.105,0.553
      									c0,0.326,0.07,0.582,0.211,0.764c0.14,0.183,0.328,0.273,0.562,0.273c0.131,0,0.248-0.029,0.35-0.088
      									c0.103-0.059,0.194-0.128,0.272-0.21l0.382,0.45C56.061,109.179,55.717,109.336,55.296,109.336"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M57.796,109.336c-0.206,0-0.399-0.05-0.58-0.149
      									c-0.181-0.099-0.327-0.244-0.438-0.436c-0.111-0.19-0.166-0.42-0.166-0.688c0-0.271,0.055-0.501,0.166-0.689
      									c0.111-0.189,0.257-0.334,0.438-0.434c0.181-0.1,0.374-0.148,0.58-0.148c0.206,0,0.398,0.049,0.577,0.148
      									c0.18,0.1,0.325,0.244,0.436,0.434c0.111,0.188,0.166,0.418,0.166,0.689c0,0.268-0.055,0.497-0.166,0.688
      									c-0.111,0.191-0.256,0.337-0.436,0.436C58.195,109.286,58.002,109.336,57.796,109.336 M57.796,108.754
      									c0.147,0,0.258-0.063,0.333-0.188c0.075-0.125,0.112-0.293,0.112-0.502c0-0.212-0.037-0.38-0.112-0.504
      									c-0.075-0.124-0.186-0.186-0.333-0.186c-0.15,0-0.262,0.062-0.335,0.186c-0.074,0.124-0.11,0.292-0.11,0.504
      									c0,0.209,0.036,0.377,0.11,0.502C57.535,108.69,57.646,108.754,57.796,108.754"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M59.47,109.277v-2.427h0.587l0.049,0.309h0.02
      									c0.104-0.099,0.219-0.185,0.345-0.258c0.125-0.072,0.27-0.109,0.433-0.109c0.264,0,0.456,0.086,0.575,0.262
      									c0.119,0.174,0.178,0.412,0.178,0.717v1.507h-0.719v-1.414c0-0.176-0.024-0.297-0.071-0.362s-0.123-0.098-0.227-0.098
      									c-0.092,0-0.17,0.02-0.235,0.061c-0.066,0.041-0.137,0.1-0.216,0.175v1.639H59.47z"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M62.984,109.336c-0.16,0-0.324-0.03-0.492-0.093
      									s-0.314-0.143-0.438-0.245l0.323-0.45c0.111,0.082,0.218,0.145,0.321,0.189c0.103,0.044,0.204,0.066,0.306,0.066
      									c0.107,0,0.186-0.02,0.234-0.058c0.049-0.037,0.074-0.087,0.074-0.149c0-0.056-0.024-0.101-0.071-0.137
      									c-0.047-0.035-0.109-0.068-0.184-0.1c-0.075-0.031-0.155-0.063-0.239-0.096c-0.098-0.039-0.195-0.088-0.292-0.146
      									c-0.096-0.059-0.177-0.135-0.242-0.229c-0.065-0.093-0.098-0.205-0.098-0.34c0-0.225,0.086-0.408,0.257-0.548
      									c0.172-0.141,0.396-0.211,0.673-0.211c0.186,0,0.35,0.032,0.492,0.097c0.142,0.062,0.263,0.133,0.364,0.213l-0.323,0.43
      									c-0.084-0.064-0.169-0.116-0.254-0.151c-0.085-0.036-0.17-0.054-0.254-0.054c-0.186,0-0.279,0.062-0.279,0.191
      									c0,0.078,0.046,0.137,0.139,0.178c0.093,0.041,0.202,0.084,0.326,0.13c0.104,0.036,0.206,0.082,0.305,0.139
      									c0.1,0.058,0.183,0.134,0.25,0.226c0.067,0.093,0.1,0.215,0.1,0.365c0,0.219-0.084,0.403-0.254,0.555
      									C63.558,109.261,63.31,109.336,62.984,109.336"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M64.438,106.851h0.719v2.426h-0.719V106.851z M64.794,106.493
      									c-0.121,0-0.219-0.034-0.294-0.104c-0.075-0.068-0.112-0.16-0.112-0.273c0-0.114,0.037-0.205,0.112-0.274
      									c0.075-0.067,0.173-0.103,0.294-0.103s0.219,0.035,0.294,0.103c0.075,0.069,0.112,0.16,0.112,0.274
      									c0,0.113-0.037,0.205-0.112,0.273C65.013,106.459,64.916,106.493,64.794,106.493"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M66.653,110.31c-0.189,0-0.36-0.021-0.513-0.062
      									c-0.154-0.043-0.276-0.11-0.367-0.201c-0.092-0.092-0.137-0.209-0.137-0.352c0-0.197,0.115-0.359,0.347-0.49v-0.02
      									c-0.062-0.043-0.115-0.097-0.159-0.162c-0.044-0.064-0.066-0.148-0.066-0.248c0-0.089,0.026-0.174,0.078-0.256
      									c0.052-0.081,0.118-0.148,0.196-0.201v-0.019c-0.085-0.06-0.161-0.144-0.228-0.254c-0.067-0.111-0.1-0.237-0.1-0.378
      									c0-0.195,0.047-0.357,0.142-0.486c0.095-0.129,0.219-0.227,0.372-0.291c0.153-0.066,0.316-0.098,0.489-0.098
      									c0.144,0,0.269,0.019,0.377,0.059h0.886v0.523h-0.387c0.023,0.035,0.042,0.082,0.057,0.137
      									c0.014,0.055,0.022,0.115,0.022,0.182c0,0.186-0.043,0.338-0.128,0.459s-0.199,0.211-0.342,0.27
      									c-0.144,0.059-0.305,0.088-0.485,0.088c-0.094,0-0.192-0.016-0.293-0.049c-0.059,0.049-0.088,0.109-0.088,0.182
      									c0,0.061,0.027,0.107,0.083,0.137c0.055,0.029,0.15,0.043,0.284,0.043h0.391c0.3,0,0.529,0.049,0.688,0.146
      									c0.158,0.096,0.237,0.254,0.237,0.472c0,0.167-0.055,0.316-0.166,0.448c-0.111,0.132-0.268,0.235-0.47,0.312
      									C67.171,110.272,66.932,110.31,66.653,110.31 M66.708,108.073c0.095,0,0.174-0.033,0.238-0.103
      									c0.063-0.067,0.095-0.17,0.095-0.304c0-0.127-0.032-0.225-0.095-0.291c-0.064-0.066-0.143-0.1-0.238-0.1
      									c-0.094,0-0.173,0.032-0.237,0.098c-0.064,0.064-0.095,0.162-0.095,0.293c0,0.134,0.031,0.236,0.095,0.304
      									C66.535,108.04,66.613,108.073,66.708,108.073 M66.767,109.86c0.163,0,0.297-0.029,0.401-0.089
      									c0.105-0.059,0.157-0.129,0.157-0.21c0-0.076-0.032-0.126-0.096-0.152c-0.063-0.025-0.155-0.039-0.276-0.039h-0.25
      									c-0.081,0-0.149-0.002-0.203-0.008c-0.054-0.004-0.1-0.012-0.139-0.021c-0.088,0.079-0.132,0.158-0.132,0.24
      									c0,0.091,0.049,0.16,0.149,0.207C66.477,109.836,66.606,109.86,66.767,109.86"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M69.062,109.336c-0.248,0-0.42-0.073-0.516-0.223
      									c-0.096-0.147-0.145-0.345-0.145-0.589v-2.678h0.72v2.707c0,0.074,0.015,0.127,0.041,0.156
      									c0.028,0.029,0.058,0.044,0.086,0.044c0.017,0,0.031-0.001,0.041-0.003c0.013-0.001,0.027-0.004,0.047-0.007l0.089,0.533
      									c-0.039,0.017-0.089,0.03-0.149,0.042C69.215,109.33,69.144,109.336,69.062,109.336"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M69.8,106.851h0.721v2.426H69.8V106.851z M70.157,106.493
      									c-0.121,0-0.217-0.034-0.293-0.104c-0.076-0.068-0.113-0.16-0.113-0.273c0-0.114,0.037-0.205,0.113-0.274
      									c0.076-0.067,0.172-0.103,0.293-0.103s0.219,0.035,0.295,0.103c0.074,0.069,0.111,0.16,0.111,0.274
      									c0,0.113-0.037,0.205-0.111,0.273C70.376,106.459,70.278,106.493,70.157,106.493"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M72.192,109.336c-0.205,0-0.398-0.05-0.58-0.149
      									c-0.18-0.099-0.326-0.244-0.438-0.436c-0.111-0.19-0.166-0.42-0.166-0.688c0-0.271,0.055-0.501,0.166-0.689
      									c0.111-0.189,0.258-0.334,0.438-0.434c0.182-0.1,0.375-0.148,0.58-0.148s0.398,0.049,0.578,0.148s0.324,0.244,0.436,0.434
      									c0.111,0.188,0.166,0.418,0.166,0.689c0,0.268-0.055,0.497-0.166,0.688c-0.111,0.191-0.256,0.337-0.436,0.436
      									C72.591,109.286,72.397,109.336,72.192,109.336 M72.192,108.754c0.148,0,0.26-0.063,0.334-0.188s0.111-0.293,0.111-0.502
      									c0-0.212-0.037-0.38-0.111-0.504s-0.186-0.186-0.334-0.186s-0.262,0.062-0.334,0.186c-0.074,0.124-0.109,0.292-0.109,0.504
      									c0,0.209,0.035,0.377,0.109,0.502C71.931,108.69,72.044,108.754,72.192,108.754"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M74.903,109.277v-3.19h0.74l0.832,1.586l0.312,0.705h0.02
      									c-0.012-0.17-0.031-0.359-0.053-0.568c-0.023-0.209-0.035-0.408-0.035-0.598v-1.125h0.686v3.19h-0.738l-0.832-1.59
      									l-0.314-0.694h-0.02c0.016,0.176,0.035,0.364,0.057,0.566c0.021,0.203,0.031,0.398,0.031,0.588v1.13H74.903z"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M78.712,109.337c-0.223,0-0.398-0.072-0.529-0.213
      									c-0.131-0.143-0.195-0.316-0.195-0.521c0-0.256,0.107-0.454,0.322-0.598s0.564-0.24,1.043-0.289
      									c-0.006-0.107-0.039-0.192-0.096-0.256s-0.152-0.096-0.285-0.096c-0.102,0-0.205,0.02-0.309,0.059
      									c-0.105,0.039-0.215,0.092-0.332,0.162l-0.262-0.476c0.154-0.095,0.318-0.171,0.492-0.229
      									c0.176-0.06,0.357-0.088,0.547-0.088c0.311,0,0.549,0.09,0.715,0.268c0.166,0.181,0.25,0.455,0.25,0.828v1.39h-0.588
      									l-0.051-0.249h-0.018c-0.102,0.091-0.211,0.165-0.326,0.223C78.976,109.308,78.849,109.337,78.712,109.337 M78.956,108.778
      									c0.082,0,0.152-0.02,0.213-0.057s0.121-0.088,0.184-0.148v-0.426c-0.254,0.031-0.43,0.084-0.527,0.154
      									c-0.1,0.069-0.148,0.151-0.148,0.246c0,0.078,0.025,0.137,0.076,0.174S78.872,108.778,78.956,108.778"
                        />
                        <polygon
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          points="80.546,109.277 80.546,108.891 81.565,107.413 80.659,107.413 
      									80.659,106.851 82.46,106.851 82.46,107.231 81.442,108.714 82.495,108.714 82.495,109.277 								"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M82.931,106.851h0.719v2.426h-0.719V106.851z M83.286,106.493
      									c-0.119,0-0.217-0.034-0.293-0.104c-0.074-0.068-0.111-0.16-0.111-0.273c0-0.114,0.037-0.205,0.111-0.274
      									c0.076-0.067,0.174-0.103,0.293-0.103c0.121,0,0.221,0.035,0.295,0.103c0.074,0.069,0.111,0.16,0.111,0.274
      									c0,0.113-0.037,0.205-0.111,0.273C83.507,106.459,83.407,106.493,83.286,106.493"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M85.323,109.336c-0.207,0-0.398-0.05-0.58-0.149
      									c-0.182-0.099-0.328-0.244-0.438-0.436c-0.111-0.19-0.166-0.42-0.166-0.688c0-0.271,0.055-0.501,0.166-0.689
      									c0.109-0.189,0.256-0.334,0.438-0.434s0.373-0.148,0.58-0.148c0.205,0,0.398,0.049,0.576,0.148
      									c0.18,0.1,0.326,0.244,0.436,0.434c0.111,0.188,0.166,0.418,0.166,0.689c0,0.268-0.055,0.497-0.166,0.688
      									c-0.109,0.191-0.256,0.337-0.436,0.436C85.722,109.286,85.528,109.336,85.323,109.336 M85.323,108.754
      									c0.146,0,0.258-0.063,0.332-0.188c0.076-0.125,0.113-0.293,0.113-0.502c0-0.212-0.037-0.38-0.113-0.504
      									c-0.074-0.124-0.186-0.186-0.332-0.186c-0.15,0-0.262,0.062-0.336,0.186s-0.109,0.292-0.109,0.504
      									c0,0.209,0.035,0.377,0.109,0.502S85.173,108.754,85.323,108.754"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M86.997,109.277v-2.427h0.586l0.049,0.309h0.02
      									c0.105-0.099,0.221-0.185,0.346-0.258c0.125-0.072,0.27-0.109,0.434-0.109c0.264,0,0.455,0.086,0.574,0.262
      									c0.119,0.174,0.18,0.412,0.18,0.717v1.507h-0.721v-1.414c0-0.176-0.023-0.297-0.07-0.362s-0.123-0.098-0.227-0.098
      									c-0.092,0-0.17,0.02-0.236,0.061c-0.064,0.041-0.137,0.1-0.215,0.175v1.639H86.997z"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M90.407,109.337c-0.221,0-0.398-0.072-0.529-0.213
      									c-0.131-0.143-0.195-0.316-0.195-0.521c0-0.256,0.107-0.454,0.324-0.598c0.215-0.144,0.562-0.24,1.041-0.289
      									c-0.006-0.107-0.037-0.192-0.096-0.256c-0.057-0.063-0.152-0.096-0.285-0.096c-0.102,0-0.205,0.02-0.309,0.059
      									c-0.105,0.039-0.215,0.092-0.332,0.162l-0.26-0.476c0.152-0.095,0.316-0.171,0.492-0.229
      									c0.174-0.06,0.355-0.088,0.545-0.088c0.311,0,0.549,0.09,0.715,0.268c0.166,0.181,0.25,0.455,0.25,0.828v1.39h-0.588
      									l-0.049-0.249h-0.02c-0.102,0.091-0.211,0.165-0.326,0.223C90.671,109.308,90.544,109.337,90.407,109.337 M90.651,108.778
      									c0.082,0,0.154-0.02,0.213-0.057c0.061-0.037,0.123-0.088,0.184-0.148v-0.426c-0.254,0.031-0.43,0.084-0.527,0.154
      									c-0.1,0.069-0.148,0.151-0.148,0.246c0,0.078,0.025,0.137,0.076,0.174S90.567,108.778,90.651,108.778"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M93.036,109.336c-0.248,0-0.422-0.073-0.518-0.223
      									c-0.096-0.147-0.145-0.345-0.145-0.589v-2.678h0.721v2.707c0,0.074,0.014,0.127,0.041,0.156s0.057,0.044,0.086,0.044
      									c0.016,0,0.029-0.001,0.041-0.003c0.012-0.001,0.027-0.004,0.047-0.007l0.088,0.533c-0.039,0.017-0.09,0.03-0.148,0.042
      									C93.188,109.33,93.116,109.336,93.036,109.336"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M94.86,109.337c-0.23,0-0.439-0.051-0.627-0.152
      									c-0.186-0.102-0.332-0.246-0.439-0.436s-0.162-0.418-0.162-0.686c0-0.264,0.055-0.49,0.164-0.68s0.252-0.335,0.428-0.438
      									c0.176-0.104,0.361-0.154,0.553-0.154c0.232,0,0.424,0.051,0.576,0.154c0.152,0.103,0.266,0.241,0.342,0.416
      									c0.076,0.174,0.115,0.372,0.115,0.594c0,0.062-0.004,0.123-0.01,0.184s-0.014,0.105-0.02,0.135h-1.453
      									c0.033,0.176,0.105,0.307,0.221,0.389c0.113,0.084,0.25,0.125,0.41,0.125c0.174,0,0.348-0.054,0.523-0.162l0.24,0.437
      									c-0.123,0.084-0.262,0.151-0.416,0.2S95.005,109.337,94.86,109.337 M94.321,107.8h0.877c0-0.135-0.031-0.244-0.096-0.33
      									c-0.062-0.087-0.168-0.13-0.311-0.13c-0.111,0-0.211,0.038-0.299,0.114C94.405,107.532,94.349,107.646,94.321,107.8"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M54.802,114.749c-0.297,0-0.535-0.108-0.715-0.325
      									c-0.179-0.218-0.269-0.523-0.269-0.917c0-0.258,0.048-0.481,0.145-0.668c0.096-0.188,0.223-0.332,0.381-0.434
      									c0.159-0.101,0.327-0.152,0.507-0.152c0.137,0,0.256,0.025,0.357,0.074c0.101,0.049,0.204,0.115,0.308,0.201l-0.019-0.406
      									v-0.916h0.406v3.484H55.57l-0.034-0.279h-0.015c-0.091,0.092-0.199,0.17-0.323,0.237S54.942,114.749,54.802,114.749
      									 M54.89,114.411c0.209,0,0.411-0.108,0.607-0.328v-1.242c-0.101-0.092-0.198-0.156-0.291-0.193
      									c-0.093-0.038-0.189-0.056-0.287-0.056c-0.127,0-0.242,0.038-0.345,0.114c-0.102,0.076-0.185,0.183-0.247,0.318
      									c-0.062,0.135-0.093,0.294-0.093,0.477c0,0.285,0.057,0.507,0.172,0.668C54.52,114.331,54.681,114.411,54.89,114.411"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M57.669,114.749c-0.212,0-0.405-0.049-0.578-0.148
      									c-0.173-0.1-0.31-0.243-0.411-0.43c-0.101-0.186-0.151-0.406-0.151-0.664c0-0.262,0.051-0.485,0.154-0.672
      									c0.102-0.186,0.235-0.328,0.398-0.43c0.164-0.101,0.335-0.152,0.514-0.152c0.304,0,0.538,0.102,0.703,0.304
      									c0.164,0.202,0.247,0.473,0.247,0.813c0,0.041-0.001,0.084-0.003,0.123c-0.001,0.041-0.006,0.076-0.012,0.106h-1.605
      									c0.016,0.251,0.095,0.452,0.237,0.603c0.142,0.149,0.327,0.225,0.556,0.225c0.114,0,0.219-0.018,0.315-0.053
      									c0.097-0.033,0.189-0.078,0.277-0.133l0.142,0.264c-0.101,0.064-0.217,0.121-0.345,0.17
      									C57.979,114.725,57.833,114.749,57.669,114.749 M56.92,113.311h1.272c0-0.241-0.051-0.425-0.154-0.55
      									c-0.103-0.127-0.247-0.189-0.433-0.189c-0.166,0-0.316,0.065-0.448,0.193C57.025,112.894,56.947,113.075,56.92,113.311"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M59.558,114.749c-0.15,0-0.258-0.047-0.325-0.14
      									c-0.067-0.093-0.101-0.226-0.101-0.397v-3.006h0.402v3.034c0,0.062,0.011,0.106,0.034,0.136
      									c0.023,0.026,0.049,0.041,0.078,0.041c0.013,0,0.025-0.002,0.037-0.003c0.011-0.002,0.028-0.004,0.051-0.008l0.054,0.304
      									c-0.026,0.014-0.057,0.023-0.093,0.029C59.659,114.746,59.613,114.749,59.558,114.749"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M60.806,114.749c-0.15,0-0.258-0.047-0.325-0.14
      									c-0.067-0.093-0.101-0.226-0.101-0.397v-3.006h0.401v3.034c0,0.062,0.012,0.106,0.035,0.136
      									c0.023,0.026,0.049,0.041,0.078,0.041c0.013,0,0.025-0.002,0.037-0.003c0.011-0.002,0.028-0.004,0.051-0.008l0.054,0.304
      									c-0.026,0.014-0.057,0.023-0.093,0.029C60.907,114.746,60.861,114.749,60.806,114.749"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M62.593,114.749c-0.212,0-0.405-0.049-0.578-0.148
      									s-0.31-0.243-0.411-0.43c-0.101-0.186-0.151-0.406-0.151-0.664c0-0.262,0.051-0.485,0.154-0.672
      									c0.102-0.186,0.235-0.328,0.398-0.43c0.164-0.101,0.335-0.152,0.514-0.152c0.304,0,0.538,0.102,0.703,0.304
      									c0.164,0.202,0.247,0.473,0.247,0.813c0,0.041-0.001,0.084-0.003,0.123c-0.001,0.041-0.006,0.076-0.012,0.106h-1.605
      									c0.016,0.251,0.095,0.452,0.237,0.603c0.142,0.149,0.327,0.225,0.556,0.225c0.114,0,0.219-0.018,0.315-0.053
      									c0.097-0.033,0.189-0.078,0.277-0.133l0.142,0.264c-0.101,0.064-0.217,0.121-0.345,0.17
      									C62.902,114.725,62.756,114.749,62.593,114.749 M61.844,113.311h1.272c0-0.241-0.051-0.425-0.154-0.55
      									c-0.103-0.127-0.247-0.189-0.433-0.189c-0.166,0-0.316,0.065-0.448,0.193C61.949,112.894,61.87,113.075,61.844,113.311"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M65.01,114.69v-3.19h1.15c0.225,0,0.43,0.03,0.616,0.091
      									c0.186,0.061,0.335,0.162,0.445,0.305c0.111,0.145,0.167,0.344,0.167,0.598c0,0.234-0.051,0.428-0.154,0.58
      									c-0.103,0.152-0.241,0.265-0.414,0.34l0.724,1.277h-0.807l-0.612-1.149h-0.396v1.149H65.01z M65.729,112.968h0.372
      									c0.189,0,0.333-0.039,0.433-0.119c0.099-0.08,0.149-0.199,0.149-0.355s-0.05-0.266-0.149-0.328
      									c-0.1-0.062-0.244-0.093-0.433-0.093h-0.372V112.968z"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M67.951,112.263h0.719v2.428h-0.719V112.263z M68.308,111.906
      									c-0.121,0-0.218-0.034-0.294-0.103c-0.075-0.068-0.112-0.16-0.112-0.274s0.037-0.205,0.112-0.274
      									c0.076-0.068,0.173-0.103,0.294-0.103c0.121,0,0.219,0.034,0.294,0.103c0.075,0.069,0.112,0.16,0.112,0.274
      									s-0.037,0.206-0.112,0.274C68.527,111.872,68.429,111.906,68.308,111.906"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M70.358,114.749c-0.225,0-0.428-0.05-0.609-0.148
      									c-0.182-0.1-0.324-0.245-0.431-0.437c-0.106-0.19-0.159-0.42-0.159-0.687c0-0.271,0.059-0.502,0.176-0.69
      									c0.119-0.19,0.273-0.334,0.465-0.433c0.193-0.1,0.4-0.15,0.623-0.15c0.148,0,0.281,0.025,0.396,0.074
      									c0.117,0.049,0.221,0.111,0.312,0.186l-0.338,0.465c-0.115-0.094-0.225-0.142-0.328-0.142c-0.172,0-0.311,0.062-0.414,0.187
      									c-0.104,0.123-0.154,0.291-0.154,0.504c0,0.207,0.051,0.376,0.154,0.501c0.104,0.126,0.234,0.188,0.389,0.188
      									c0.078,0,0.156-0.018,0.23-0.052c0.076-0.034,0.145-0.076,0.207-0.125l0.283,0.47c-0.121,0.105-0.252,0.18-0.393,0.223
      									C70.63,114.728,70.491,114.749,70.358,114.749"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M72.536,114.75c-0.232,0-0.441-0.052-0.627-0.152
      									s-0.332-0.247-0.441-0.437c-0.105-0.188-0.16-0.416-0.16-0.685c0-0.264,0.055-0.491,0.164-0.68s0.252-0.335,0.428-0.438
      									c0.176-0.103,0.361-0.154,0.553-0.154c0.232,0,0.424,0.052,0.576,0.154c0.15,0.104,0.266,0.241,0.342,0.416
      									c0.076,0.174,0.115,0.373,0.115,0.596c0,0.061-0.004,0.123-0.01,0.183c-0.008,0.06-0.014,0.104-0.02,0.136h-1.453
      									c0.033,0.176,0.105,0.305,0.219,0.389c0.115,0.082,0.252,0.123,0.412,0.123c0.172,0,0.348-0.053,0.523-0.16l0.24,0.435
      									c-0.123,0.085-0.264,0.152-0.416,0.201C72.827,114.725,72.679,114.75,72.536,114.75 M71.997,113.213h0.877
      									c0-0.134-0.033-0.244-0.096-0.33c-0.064-0.087-0.168-0.13-0.311-0.13c-0.111,0-0.211,0.038-0.299,0.115
      									C72.081,112.944,72.024,113.06,71.997,113.213"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M73.983,114.69v-2.427h0.588l0.049,0.426h0.02
      									c0.088-0.164,0.195-0.285,0.318-0.364c0.125-0.08,0.248-0.121,0.373-0.121c0.066,0,0.125,0.004,0.17,0.012
      									c0.047,0.009,0.086,0.021,0.117,0.037l-0.117,0.623c-0.041-0.015-0.084-0.023-0.125-0.03s-0.086-0.009-0.139-0.009
      									c-0.092,0-0.188,0.033-0.287,0.1s-0.182,0.182-0.246,0.346v1.408H73.983z"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M76.94,114.749c-0.225,0-0.428-0.05-0.609-0.148
      									c-0.182-0.1-0.324-0.245-0.432-0.437c-0.105-0.19-0.158-0.42-0.158-0.687c0-0.271,0.059-0.502,0.176-0.69
      									c0.119-0.19,0.273-0.334,0.465-0.433c0.193-0.1,0.4-0.15,0.623-0.15c0.148,0,0.283,0.025,0.396,0.074
      									c0.117,0.049,0.221,0.111,0.312,0.186l-0.338,0.465c-0.115-0.094-0.225-0.142-0.328-0.142c-0.172,0-0.311,0.062-0.414,0.187
      									c-0.104,0.123-0.154,0.291-0.154,0.504c0,0.207,0.051,0.376,0.154,0.501c0.104,0.126,0.232,0.188,0.389,0.188
      									c0.078,0,0.156-0.018,0.23-0.052c0.076-0.034,0.145-0.076,0.207-0.125l0.281,0.47c-0.119,0.105-0.25,0.18-0.391,0.223
      									C77.212,114.728,77.073,114.749,76.94,114.749"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M78.169,114.69v-3.43h0.719v0.841l-0.035,0.437
      									c0.092-0.082,0.199-0.158,0.322-0.229c0.121-0.07,0.264-0.105,0.428-0.105c0.264,0,0.455,0.088,0.574,0.262
      									c0.119,0.175,0.178,0.414,0.178,0.718v1.507h-0.719v-1.414c0-0.176-0.023-0.297-0.07-0.361
      									c-0.047-0.065-0.123-0.099-0.227-0.099c-0.092,0-0.17,0.021-0.236,0.062c-0.064,0.041-0.137,0.099-0.215,0.174v1.639H78.169
      									z"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M82.048,114.75c-0.23,0-0.439-0.052-0.625-0.152
      									s-0.334-0.247-0.441-0.437c-0.107-0.188-0.16-0.416-0.16-0.685c0-0.264,0.055-0.491,0.164-0.68s0.252-0.335,0.428-0.438
      									c0.176-0.103,0.361-0.154,0.553-0.154c0.232,0,0.424,0.052,0.574,0.154c0.152,0.104,0.268,0.241,0.344,0.416
      									c0.076,0.174,0.115,0.373,0.115,0.596c0,0.061-0.004,0.123-0.01,0.183c-0.008,0.06-0.014,0.104-0.02,0.136h-1.453
      									c0.031,0.176,0.105,0.305,0.219,0.389c0.115,0.082,0.252,0.123,0.412,0.123c0.172,0,0.348-0.053,0.523-0.16l0.24,0.435
      									c-0.125,0.085-0.264,0.152-0.416,0.201C82.341,114.725,82.192,114.75,82.048,114.75 M81.511,113.213h0.877
      									c0-0.134-0.033-0.244-0.096-0.33c-0.064-0.087-0.168-0.13-0.311-0.13c-0.111,0-0.211,0.038-0.299,0.115
      									C81.595,112.944,81.536,113.06,81.511,113.213"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M45.345,114.759c-3.124,0-5.661-2.722-5.661-6.08
      									c0-3.356,2.533-6.078,5.658-6.078h2.105v1.263h-2.058c-2.475,0-4.526,2.159-4.526,4.815c0,2.658,2.009,4.813,4.482,4.813
      									h4.73v1.267H45.345z"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M47.447,107.654h-2.091c-0.532,0-0.963,0.465-0.963,1.038v3.9
      									c-0.557-0.097-0.844-0.268-1.2-0.51l-0.014-3.355c0-1.285,0.965-2.325,2.161-2.325h2.107V107.654z"
                        />
                        <path
                          clipPath={`url(#batteria56v1500cicliom_${idVariant}_SVGID_14_)`}
                          fill="#1A375D"
                          d="M47.932,104.489c2.133,0,3.87,1.836,3.908,4.117v6.152h-1.16v-6.166
      									c0-1.62-1.225-2.846-2.733-2.846h-2.602c-1.506,0-2.749,1.219-2.749,2.838l0.008,2.988
      									c-0.721-0.761-1.167-1.726-1.167-2.896c0-2.316,1.749-4.195,3.906-4.195L47.932,104.489z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </IconBase>
  )
}

export default Batteria56V1500CicliOm
